import { GetAlertInitialBodyQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAlertInitialBody/getAlertInitialBodyQuery.type';
import { getAlertInitialBodyFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAlertInitialBody/getAlertInitialBodyQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getAlertInitialBodyQueryOptions = (
  params: GetAlertInitialBodyQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GetAlertInitialBodyQueryParamsType', params],
    queryFn: () => getAlertInitialBodyFunction(params),
  });
};
